import { Container } from 'inversify';

import { AnalyticsStore } from './stores/analytics.store';
import { ClientDataStore } from './stores/client-data.store';
import { HomeStore } from './stores/home.store';
import { IosFocusStore } from './stores/ios-focus.store';
import { LoadingStore } from './stores/loading.store';
import { LoggerStore } from './stores/logger.store';
import { MembershipNameTypeStore } from './stores/membership-name-type.store';
import { RouterStore } from './stores/router.store';
import { UIStatusStore } from './stores/ui-status.store';
import { InvoiceStore } from 'src/invoice/stores/invoice.store';

export const coreContainer = new Container();

coreContainer.bind(AnalyticsStore).toSelf().inSingletonScope();
coreContainer.bind(ClientDataStore).toSelf().inSingletonScope();
coreContainer.bind(HomeStore).toSelf().inSingletonScope();
coreContainer.bind(IosFocusStore).toSelf().inSingletonScope();
coreContainer.bind(LoadingStore).toSelf().inSingletonScope();
coreContainer.bind(LoggerStore).toSelf().inSingletonScope();
coreContainer.bind(MembershipNameTypeStore).toSelf().inSingletonScope();
coreContainer.bind(RouterStore).toSelf().inSingletonScope();
coreContainer.bind(UIStatusStore).toSelf().inSingletonScope();
